import { useEffect, useState } from 'react';
import { Typography, Box, Link } from '@mui/material';
import CustomAppBar from '../components/CustomAppBar';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import Image from 'mui-image';
import PrimaryButton from '../components/PrimaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_HEART_VERIFICATION_TOPIC } from '../constants';
import { useNavigate } from 'react-router-dom';
import { subscribeToTopics, unsubscribeFromTopics } from '../api/mqtt'
import { Player } from '@lottiefiles/react-lottie-player'   // lottie animation
import { updateIsVerified } from '../redux/heartSlice';

function AddHeartVerify() {
    const [verified, setVerified] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const currentHeartMAC = useSelector((state) => state.heart.tempHeart.id);
    const subscribedTopics = useSelector((state) => state.mqtt.subscribedTopics); // avoid resubscribing to topics
    
    useEffect(() => {

        
        // Heart verification topic is specific to each heart mac (Ex: LumasHearts/hearts/verify/MAC)
        // Change MAC format from ":" delimiter to "-" since MQTT topics do not accept ":" as a delimiter
        let heartTopicMAC = currentHeartMAC.split(":").join("-")
        const heartTopicName = ADD_HEART_VERIFICATION_TOPIC + "/" + heartTopicMAC

        // Subscribe on mount
        subscribeToTopics([heartTopicName], dispatch, addHeartVerifyMQTTListener, subscribedTopics);
        
        return () => {
            // Unsubscribe on unmount
            unsubscribeFromTopics([ADD_HEART_VERIFICATION_TOPIC], dispatch, subscribedTopics);
        };
    }, []);
    
    // Listener added to heartVerify topic subscription
    // Subscribe to the /hearts/verify MQTT topic to listen for verification, checks if MAC address is same as the one being added.
    // Example MQTT message: "shortPress,00:00:00:00:00:00"
    const addHeartVerifyMQTTListener = (topic, message) => {
        const messageString = message.toString();
        console.log(messageString)
        console.log('Current Heart MAC:', currentHeartMAC);

        if (messageString.startsWith("shortPress")) {
            const macAddress = messageString.split(',')[1].trim();
            console.log('MAC address:', macAddress);

            // Check if MAC address matches the heart being added
            if (macAddress === currentHeartMAC) {
                setVerified(true)
                dispatch(updateIsVerified(true))
            } 
        }
    }

    const handleContinue = () => {
        navigate('/add-heart/name');
    }

    return (
        <AppContainer>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>


                <CustomAppBar />
                <Navbar />
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                    <TextContainer>
                        <Typography variant="h5">Verify Heart</Typography>
                        <Typography variant="body1" mt={1.2} sx={{ fontSize: '16px' }}>
                        Use a pin or paper clip to <strong>briefly press the button</strong> on the bottom of your heart to link it to your
                        account, as shown in the image below.
                        </Typography>
                        {/* Instruction image */}
                        {!verified && (
                            <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                            }}
                            >
                                    <Image
                                    src="https://heartappimages.s3.us-west-2.amazonaws.com/addHeartHelp.jpg"
                                    width={300}
                                />
                            </Box>
                        )}
                        {/* Lottie Animation */}
                        {verified && (
                            <Box
                            sx={{
                                margin: '0 auto',
                                width: 300,
                                height: 300,
                                marginBottom: 2,
                            }}
                            >
                                <Player autoplay keepLastFrame speed={1} src="/success.json" style={{ width: '100%', height: '100%' }} />
                            </Box>
                        )}
                        <Typography
                        variant="body2"
                        mt={1.2}
                        sx={{ fontSize: '12px', fontStyle: 'italic' }}
                        >
                        Having trouble? Make sure your heart is connected to Wi-Fi first. If you're still having
                        trouble, please reference the <a href="https://lumas.live/manual">Lumas Manual</a>. If you're still facing issues, don't hesitate to <a href="mailto:support@lumas.live">contact support.</a>
                        </Typography>
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                <TextContainer customStyles={{marginBottom: '40px'}}>
                    <PrimaryButton onClick={handleContinue} disabled={!verified} text={"Continue"} customStyles={{width: '100%'}} />
                </TextContainer>
            </Box>
        </AppContainer>
    );
}

export default AddHeartVerify;
